<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { AboutUs } from '~~/server/api/corporation/profile'
import { SrcSet } from '~/composables/useSrcSet'

export interface PagesAboutProfileAboutUsProps {
    data: AboutUs
}

const props = defineProps<PagesAboutProfileAboutUsProps>()
const { $formatTableHtml } = useNuxtApp()

const mobileImageSrc = computed((): SrcSet | undefined => {
    const first = props.data.mobile_images[0]
    if (!first?.path) return
    return useSrcSet(first.path)
})
</script>
<template>
  <article class="row justify-content-between flex-md-row-reverse">
    <div class="col-12 col-md-5 mb-8">
      <ImageGrid class="w-100 d-none d-md-block justify-content-center">
        <ImageGridItem
          v-for="(image, index) in props.data.desktop_images"
          :key="`about-us-image-${index}`"
          :image="image"
          :index="index"
          aria-hidden="true"
          :alt="image.alt"
        />
      </ImageGrid>

      <img
        :src="mobileImageSrc?.src"
        :srcset="mobileImageSrc?.srcSet"
        :width="220"
        :height="147"
        class="w-100 mb-md-3 mb-md-6 h-auto rounded d-block d-md-none"
        loading="lazy"
        decoding="async"
        aria-hidden="true"
        alt=""
      >
    </div>

    <div class="col-12 col-md-6">
      <Heading
        level="h2"
        class="mb-4"
      >
        {{ props.data.title }}
      </Heading>

      <Typo>
        <div v-html="$formatTableHtml(props.data.description)" />
      </Typo>
    </div>
  </article>
</template>
